import {isElementVisible} from "@tools/utils/common.tsx";

const getFirstVisibleElement = (selector: string): HTMLElement | undefined => {
    const nodes = document.querySelectorAll(selector);

    for (let i = 0; i < nodes.length; i++) {
        const element = nodes[i] as HTMLElement;
        if (isElementVisible({element})) {
            return element;
        }
    }

    return undefined;
};

function activateSidebar({id_sidebar, action, content, boton_str}: {id_sidebar: string, action?: 'activate' | 'deactivate', content?: string, boton_str?: string
}) {

    let statusToSave: boolean = false;
    if (!action) {
        action = JSON.parse(localStorage.getItem('activeSideBar') || 'false') ? 'activate' : "deactivate";
    }
    if (action === 'activate') {
        statusToSave = true;
    } else if (action === 'deactivate') {
        statusToSave = false;
    }

    const toggleClass = (element: HTMLElement | null, className: string, reverse: boolean = false) => {
        if (!element) return;
        if (action === 'activate') {
          if (reverse) {
            element.classList.add(className);
          } else {
            element.classList.remove(className);
          }
        } else if (action === 'deactivate') {
          if (reverse) {
            element.classList.remove(className);
          } else {
            element.classList.add(className);
          }
        }
    };

    const sidebarElement = document.getElementById(id_sidebar);
    toggleClass(sidebarElement, 'active');

    if (content) {
        const contentElement = document.getElementById(content);
        toggleClass(contentElement, 'active');
    }

    const collapseElements = document.querySelectorAll('.collapse.in');
    collapseElements.forEach((element) => {
        toggleClass(element as HTMLElement, 'in');
    });

    const expandedElements = document.querySelectorAll('a[aria-expanded="true"]');
    expandedElements.forEach((element) => {
        if (action === 'deactivate') {
            element.setAttribute('aria-expanded', 'false');
        } else if (action === 'activate') {
            element.setAttribute('aria-expanded', 'true');
        }
    });

    const overlayElement = document.querySelector('.overlay') as HTMLElement | null;
    toggleClass(overlayElement, 'active');

    if (boton_str) {
        const button1 = document.getElementById(`${boton_str}-1`);
        const button2 = document.getElementById(`${boton_str}-2`);

        toggleClass(button1, 'd-none', true);
        toggleClass(button2, 'd-none', true);
    }

    localStorage.setItem('activeSideBar', JSON.stringify(statusToSave));
}

const handleCartButton = async (open: boolean) => {
    const selector = open ? '.cartButtonClass' : '.ant-drawer-close';
    const cartBtn = getFirstVisibleElement(selector);
    cartBtn?.click();
};

const handleExpandCategory = async (open: boolean) => {
    const expandBtn = getFirstVisibleElement('.expandCategoryBtnClass');
    if (expandBtn && open !== (expandBtn.dataset.open === 'true')) {
        expandBtn.click();
    }
};

const handleMenuWebBtn = async (open: boolean) => {
    const menuBtn = getFirstVisibleElement('.menuWebBtnClass');
    if (menuBtn && open !== (menuBtn.getAttribute('aria-expanded') === 'true')) {
        menuBtn.click();
    }
};

const handleCatalogueFilters = async (open: boolean) => {
    const toggle = getFirstVisibleElement('.catalogue-toolbar__toggle');
    const isExpanded = toggle?.getAttribute('aria-expanded') === 'true';

    if (toggle && open !== isExpanded) {
        toggle.click();
    }

    if (!open) {
        const drawerClose = getFirstVisibleElement('.catalogue-menu__drawer-close');
        if (drawerClose) {
            drawerClose.click();
        }
    }
};

export const tourFunctions: Record<string, () => void | Promise<void>> = {
    openSideMenu: () => {activateSidebar({id_sidebar: 'MenuLateral', content: 'Main', boton_str: 'boton', action: "activate"});},
    closeSideMenu: () => {activateSidebar({id_sidebar: 'MenuLateral', content: 'Main', boton_str: 'boton', action: "deactivate"});},
    openCart: async () => {await handleCartButton(true)},
    closeCart: async () => {await handleCartButton(false)},
    openCatalogo: () => handleExpandCategory(true),
    closeCatalogo: () => handleExpandCategory(false),
    openWebMenu: () => handleMenuWebBtn(true),
    closeWebMenu: () => handleMenuWebBtn(false),
    openCatalogueFilters: () => handleCatalogueFilters(true),
    closeCatalogueFilters: () => handleCatalogueFilters(false),
}
